import React from "react";
import "../styles/components/rt-chart.scss";

const RTChart = ({ datas, sum, apdex, avg }) => (
  <div className="response-time">
    <div className="numbers">
      <strong>{formatMsOrSec(avg)}</strong>
      <span className="legend">
        <i className="server">Response time</i>
      </span>
    </div>
    <div className="history">
      <div className="rt-chart">
        {datas.map((data, index) => {
          const divStyle = {
            height: `${(sum === 0 ? sum : data / sum) * 100}%`
          };
          const delimiter = Math.log2(apdex / 0.125);
          const cond = (index, data) => {
            let temp = "";
            if (index <= delimiter) {
              temp = "good";
            } else if (index <= delimiter + 2) {
              temp = "tolerated";
            } else {
              temp = "frustrated";
            }
            if (data === 0 && index !== datas.length - 1) {
              temp = temp + " compact";
            }
            return temp;
          };

          return (
            <output
              className={cond(index, data)}
              style={{ flex: widths[index] }}
              key={index}
            >
              <div className="ends-at">{generateLabels(index)}</div>
              <i style={divStyle}>
                <span className="top">{data !== 0 ? data : ""}</span>
              </i>
            </output>
          );
        })}
      </div>
    </div>
  </div>
);

const widths = [11, 11, 16, 22, 32, 45, 63];

const generateLabels = index => {
  let label = "error";
  if (index < 3) {
    label = `${Math.pow(2, index) * 125}ms`;
  } else if (index < 7) {
    label = `${Math.pow(2, index) * 0.125}s`;
  } else if (index === 7) {
    label = "+8s";
  }
  return label;
};

const formatMsOrSec = data => {
  if (data < 1000) {
    return `${data} ms`;
  } else {
    return `${(data / 1000).toFixed(2)} S`;
  }
};

export default RTChart;
